var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.586 15.35V1.25a1.25 1.25 0 112.5 0v14.1h2.786a1 1 0 01.647 1.762l-3.936 3.345a1 1 0 01-1.295 0L.352 17.112A1 1 0 011 15.35h2.586zM10.836 0h10.833a1.25 1.25 0 010 2.5H10.836a1.25 1.25 0 010-2.5zm0 5h8.5a1.25 1.25 0 110 2.5h-8.5a1.25 1.25 0 010-2.5zm0 5h5.5a1.25 1.25 0 110 2.5h-5.5a1.25 1.25 0 010-2.5z",
    fill: "#304256",
    fillRule: "evenodd"
  })));
}

export default SvgSort;